<template>
  <div class="app">
    <carousel firstslide="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Fheader%2Fa-(23).png?alt=media&token=b5b5df62-cac6-47ce-b7eb-bc40152bce2a" 
    secondslide="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Fheader%2Fa-(23).png?alt=media&token=b5b5df62-cac6-47ce-b7eb-bc40152bce2a" 
    thirdslide="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Fheader%2Fa-(23).png?alt=media&token=b5b5df62-cac6-47ce-b7eb-bc40152bce2a" />
    <questions />
    <accordion />
  </div>
</template>
<style lang="scss" scoped>
</style>
<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbIcon,
  mdbJumbotron,
  mdbNavItem,
  mdbListGroup,
  mdbEdgeHeader
} from "mdbvue";
import questions from "@/components/questions";
import accordion from "@/components/accordion";
import carousel from "@/components/carousel";

export default {
  name: "transportauftrag",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbJumbotron,
    mdbNavItem,
    mdbListGroup,
    mdbEdgeHeader,
    questions,
    accordion,
    carousel
  }
};
</script>